import { inlineObjectFieldStyles } from 'components/DataEntry/Form';

export const formStyles = {
  form: {
    formWidth: '800px',
    container: { pt: 2, pl: 2 },
  },
  radioField: {
    radioGroupInnerWrapper: { isInline: false, w: 'full' },
  },
  objectField: {
    ...inlineObjectFieldStyles,
    propertyContainer: { w: '50%' },
  },
};
